/**
 * Loading skeleton for task cards
 * Shows animated placeholders while tasks are loading
 */
export function TaskCardSkeleton({ count = 3 }: { count?: number }) {
  return (
    <div className="space-y-3">
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          className="flex items-start gap-3 p-4 rounded-2xl border border-border bg-card animate-pulse"
        >
          {/* Checkbox skeleton */}
          <div className="mt-0.5 h-6 w-6 rounded border-2 border-muted-foreground/20 bg-muted/20" />

          {/* Content skeleton */}
          <div className="flex-1 space-y-2">
            {/* Title */}
            <div className="h-4 bg-muted/40 rounded w-3/4" />
            
            {/* Metadata */}
            <div className="flex gap-2">
              <div className="h-5 w-12 bg-muted/30 rounded" />
              <div className="h-5 w-16 bg-muted/30 rounded" />
            </div>
          </div>

          {/* Menu button skeleton */}
          <div className="h-6 w-6 bg-muted/30 rounded" />
        </div>
      ))}
    </div>
  );
}
